import { render, staticRenderFns } from "./resultado-reconsideracion.vue?vue&type=template&id=35ea1ab7&"
import script from "./resultado-reconsideracion.component.ts?vue&type=script&lang=ts&"
export * from "./resultado-reconsideracion.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports